import { useState, useCallback, useEffect, useRef } from 'react';

// Personel ve varlık içe aktarma işlerinin durum yoklaması (2026-10-19, vMind).
// Eski hâl iki sayfada setInterval idi ve hiç durmuyordu: api.js GET hatalarını reject ETMEZ, EMPTY_RESPONSE
// ({ status: false }) ile resolve eder — `catch` hiç çalışmaz, `status` boolean false olduğundan terminal sayılmaz.
// CORS reddi ya da 404 (iş başka pod'da) olunca ekran sonsuza kadar döndü, interceptor 2 sn'de bir toast bastı.
// Burada: istekler üst üste binmesin diye setTimeout zinciri; geçerli yanıt = `status` METİN; art arda
// IMPORT_POLL_MAX_FAILURES geçersiz yanıtta yoklama durur ve `statusLost` set edilir (çağıran satır içi mesaj
// + "Tekrar Dene" gösterir — bileşen toast'ı YOK, kural). İş sunucuda sürüyor olabilir; bu bir başarısızlık damgası değil.
export const IMPORT_POLL_INTERVAL_MS = 2000;
export const IMPORT_POLL_MAX_FAILURES = 5;

const TERMINAL = ['completed', 'failed'];

export default function useImportStatusPolling(fetchStatus) {
  const [importStatus, setImportStatus] = useState(null);
  const [statusLost, setStatusLost] = useState(false);
  const timerRef = useRef(null);
  const importIdRef = useRef(null);
  const failuresRef = useRef(0);
  const fetchRef = useRef(fetchStatus);
  fetchRef.current = fetchStatus;

  const stopPolling = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  // Unmount'ta bekleyen yoklamayı temizle.
  useEffect(() => stopPolling, [stopPolling]);

  const poll = useCallback(async () => {
    const importId = importIdRef.current;
    let res = null;
    try {
      res = await fetchRef.current(importId);
    } catch {
      res = null;
    }
    // Sıfırlama ya da yeni iş yoklama sürerken geldiyse bu yanıt bayattır.
    if (importIdRef.current !== importId) return;

    const status = res?.data?.status;
    if (typeof status === 'string') {
      failuresRef.current = 0;
      setImportStatus(res.data);
      if (TERMINAL.includes(status)) {
        timerRef.current = null;
        return;
      }
    } else {
      failuresRef.current += 1;
      if (failuresRef.current >= IMPORT_POLL_MAX_FAILURES) {
        timerRef.current = null;
        setStatusLost(true);
        return;
      }
    }
    timerRef.current = setTimeout(poll, IMPORT_POLL_INTERVAL_MS);
  }, []);

  const startPolling = useCallback((importId) => {
    stopPolling();
    importIdRef.current = importId;
    failuresRef.current = 0;
    setStatusLost(false);
    timerRef.current = setTimeout(poll, IMPORT_POLL_INTERVAL_MS);
  }, [poll, stopPolling]);

  // "Tekrar Dene": aynı işi baştan yokla.
  const retryPolling = useCallback(() => {
    if (importIdRef.current) startPolling(importIdRef.current);
  }, [startPolling]);

  const resetPolling = useCallback(() => {
    stopPolling();
    importIdRef.current = null;
    failuresRef.current = 0;
    setStatusLost(false);
    setImportStatus(null);
  }, [stopPolling]);

  return { importStatus, statusLost, startPolling, retryPolling, resetPolling };
}
